import { z } from "zod";

import { fetchPresignedDownloadUrl, type FetchJson } from "./presignedDownload";

const ConvertToPdfResponseSchema = z.object({
  pdf_url: z.string().optional(),
});

const PDF_FILE_EXTENSION = ".pdf";

export type CoreRequest = (path: string, options: RequestInit) => Promise<unknown>;

export async function fetchConvertedPdfUrl(fetchCore: CoreRequest, storageUrl: string): Promise<string> {
  const raw = await fetchCore("/convert-to-pdf", {
    method: "POST",
    body: JSON.stringify({ storage_url: storageUrl }),
  });
  const parsed = ConvertToPdfResponseSchema.safeParse(raw);
  if (!parsed.success || !parsed.data.pdf_url) {
    throw new Error("convert-to-pdf returned no pdf_url");
  }
  return parsed.data.pdf_url;
}

export function storedFileIsPdf(fileName: string): boolean {
  return fileName.toLowerCase().endsWith(PDF_FILE_EXTENSION);
}

export function fetchStoredFilePdfUrl(fetchWeb: FetchJson, fetchCore: CoreRequest, storageUrl: string, fileName: string): Promise<string> {
  return storedFileIsPdf(fileName)
    ? fetchPresignedDownloadUrl(fetchWeb, storageUrl, fileName)
    : fetchConvertedPdfUrl(fetchCore, storageUrl);
}
